import { mapServerToSpecificationsBase } from './map-server-to-specifications-base.js';
import { getSpecificationItems } from '../utils/get-specification-items.js';

const mapServerToAccessoriesSpecifications = (serverVariant, brand)=>{
    var ref;
    const serverSpecifications = {
        accessoryColor: serverVariant.variantTypeDetails.color,
        accessoryType: (ref = serverVariant.variantTypeDetails.accessoryType) === null || ref === void 0 ? void 0 : ref.displayName,
        material: serverVariant.variantTypeDetails.material
    };
    return [
        ...mapServerToSpecificationsBase(serverVariant, brand),
        ...getSpecificationItems(serverSpecifications), 
    ];
};

export { mapServerToAccessoriesSpecifications };
//# sourceMappingURL=map-server-to-accessories-specifications.js.map
